//external
import React, { createContext, useEffect, useState } from 'react';
import { useLocation } from 'react-router';
//internal
import Route from '../../routes/Route';
import PriceTables from './list';
import PriceTableEdit from './edit';
import PriceTableDelete from './delete';

export const FilterPriceTable = createContext({});

export default function Routes() {
  const [filter, setFilter] = useState({
    search: "",
    page: 1,
  });

  let location = useLocation();

  useEffect(() => {
    const split = location?.pathname.split('/');
    if (split[1] !== "product_price_table") {
      setFilter({
        search: "",
        page: 1,
      });
    }
  }, [location, setFilter]);

  return (
    <FilterPriceTable.Provider value={{ filter, setFilter }}>
      <Route path="/premixapp/product_price_table" exact component={PriceTables} isPrivate/>      
      <Route path="/premixapp/product_price_table/add" exact component={PriceTableEdit} isPrivate/>
      <Route path="/premixapp/product_price_table/edit/:id" exact component={PriceTableEdit} isPrivate/>
      <Route path="/premixapp/product_price_table/delete/:id" exact component={PriceTableDelete} isPrivate/>
    </FilterPriceTable.Provider>
  )
}